import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "monthlyBtn", "annualBtn",
    "starterPrice", "starterPeriod",
    "proPrice", "proPeriod",
    "teamPrice", "teamPeriod"
  ]

  static prices = {
    starter: { monthly: 49, annual: 490 },
    pro:     { monthly: 149, annual: 1490 },
    team:    { monthly: 249, annual: 2490 }
  }

  connect() {
    this.select({ currentTarget: { dataset: { period: "monthly" } } })
  }

  select(event) {
    const period = event.currentTarget.dataset.period
    this.period = period

    // Toggle button styles
    this.monthlyBtnTarget.classList.toggle("bg-ink", period === "monthly")
    this.monthlyBtnTarget.classList.toggle("text-white", period === "monthly")
    this.annualBtnTarget.classList.toggle("bg-ink", period === "annual")
    this.annualBtnTarget.classList.toggle("text-white", period === "annual")

    const prices = this.constructor.prices

    if (period === "annual") {
      this.starterPriceTarget.textContent = prices.starter.annual
      this.starterPeriodTarget.textContent = "/ year"
      this.proPriceTarget.textContent = prices.pro.annual
      this.proPeriodTarget.textContent = "/ year"
      this.teamPriceTarget.textContent = prices.team.annual
      this.teamPeriodTarget.textContent = "/ year"
    } else {
      this.starterPriceTarget.textContent = prices.starter.monthly
      this.starterPeriodTarget.textContent = "/ month"
      this.proPriceTarget.textContent = prices.pro.monthly
      this.proPeriodTarget.textContent = "/ month"
      this.teamPriceTarget.textContent = prices.team.monthly
      this.teamPeriodTarget.textContent = "/ month"
    }
  }
}
